import { Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

export const MfaPageContainer = (props) => {
    const { children } = props;
    return (<Grid container className="mt-10">{children}</Grid>)
  }
export const MfaPageBody = (props) => {
    const { children } = props;
    return (<Grid item xs={12} className="flex flex-col space-y-3 text-sm">{children}</Grid>)
  }
export const MfaPageTitle = (props) => {
    const { children } = props;
    return (<Grid item xs={12}><div id="mfaPageTitle" className="font-light text-2xl mb-3">{children}</div></Grid>)
  }
  MfaPageContainer.propTypes, MfaPageBody.propTypes, MfaPageTitle.propTypes = {
    children: PropTypes.element
  }